module.exports = __webpack_public_path__ + "dni-02-01.png?bda472fa019c09f137e1a66a59bd5570";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dni-02-01.png
// module id = 635
// module chunks = 0 2 7 8 9 10 11 16